/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  TerminationService,
  Wealthlane_AwardService_Dtos_Response_ResponseDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePostTerminationParticipantV2 = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  setReleaseItem: (items: any) => void,
  openReleaseItemAlert: () => void,
  openReleaseItemErrorAlert: () => void,
  setStoredFormValues: (values: any) => void
): UseMutationResult<
  Wealthlane_AwardService_Dtos_Response_ResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ payload, autoRemovePreRelease }: { payload: any; autoRemovePreRelease?: boolean }) => {
      setStoredFormValues(payload);
      return await handleRequest(
        TerminationService.postApiAwardApiAppTerminationTerminateParticipant(autoRemovePreRelease, payload)
      );
    },
    {
      onSuccess: (response: any, { autoRemovePreRelease}: { payload: any; autoRemovePreRelease?: boolean }) => {
         if (response?.rsuResponse?.success === true && !autoRemovePreRelease) {
          setReleaseItem(response?.rsuResponse?.releaseItems);
          openReleaseItemAlert();
        }
        if ( response?.rsuResponse?.success === false && !autoRemovePreRelease) {
          setReleaseItem(response?.rsuResponse?.releaseItems);
          openReleaseItemErrorAlert();
        }
        if (response?.rsuResponse?.success === true && autoRemovePreRelease) {
          void queryClient.invalidateQueries('getCustomerParticipantList');
          void queryClient.invalidateQueries('dt-v2-page');
          closeModal();
          toast.success(<ToastComponent label='Success' message={`Participant Terminated.`} />);
        }
        if (response != null && response?.success === true) {
          void queryClient.invalidateQueries('getCustomerParticipantList');
          void queryClient.invalidateQueries('dt-v2-page');
          closeModal();
          toast.success(<ToastComponent label='Success' message={`Participant Terminated.`} />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostTerminationParticipantV2;
